import { PropsWithChildren } from 'react';

import clsx from 'clsx';

export function Skeleton({
  className,
  children,
}: PropsWithChildren<{ className?: string }>) {
  return (
    <div className={clsx('rounded-full bg-[#4a386e]', className)}>
      {children}
    </div>
  );
}
